module.exports = __webpack_public_path__ + "media/images/arrow-right-67a672806df4be671bbab2c7da2ddcc2.svg";